<myp-inline-loader [loading]="loading" height="200px" spinnerName="workspaceDetailLoader"></myp-inline-loader>
@if (connectionData.status == "pending" && (!connectionData.initiatedBy || connectionData.initiatedBy == user.id)) {
  <div class="d-flex justify-content-center align-items-center w-full h-full">
    <div class="text-center">
      <img [src]="connectionData.photo || './assets/images/default_avatar.jpg'" class="image-border round m-b-20" style="width: 100px; height: 100px" />
      <br />
      @if (connectionData.name) {
        <h2>{{ connectionData.name }}</h2>
      }
      <p>{{ connectionData.name || connectionData.email }} has not yet responded to your invitation.</p>
      <button class="btn btn-primary" (click)="nudge()">Nudge Them</button>
    </div>
  </div>
}
@if (connectionData.status == "pending" && connectionData.initiatedBy && connectionData.initiatedBy != user.id) {
  <div class="d-flex justify-content-center align-items-center w-full h-full">
    <div class="text-center">
      <img [src]="connectionData.photo || './assets/images/default_avatar.jpg'" class="image-border round" style="width: 100px; height: 100px" />
      <br />
      @if (connectionData.name) {
        <h2>{{ connectionData.name }}</h2>
      }
      <p>{{ connectionData.name }} invited you to connect!</p>
      @if (connectionData.inviteMessage) {
        <div class="p-20 m-y-20" style="max-width: 600px; background-color: rgba(0, 0, 0, 0.2); border-radius: 20px">{{ connectionData.inviteMessage }}</div>
      }
      <button class="btn btn-primary" (click)="updateInvitation(true)">Accept Invitation</button>
      &nbsp;&nbsp;&nbsp;
      <button class="btn btn-danger" (click)="updateInvitation(false)">Reject Invitation</button>
    </div>
  </div>
}
@if (connectionData.status == "rejected") {
  <div class="d-flex justify-content-center align-items-center w-full h-full">
    <div class="text-center">
      <img [src]="connectionData.photo || './assets/images/default_avatar.jpg'" class="image-border round" style="width: 100px; height: 100px" />
      <br />
      @if (connectionData.name) {
        <h2>{{ connectionData.name }}</h2>
      }
      <p>{{ connectionData.name }} has rejected your invitation.</p>
      <button class="btn btn-danger" (click)="deleteInvitation()">Delete Connection Request</button>
    </div>
  </div>
}
@if (!loading && (connectionData.status == "active" || connectionData.status == "deleted")) {
  <div class="container satellite-page">
    <ng-container>
      <div class="d-flex d-md-flex justify-space-between align-items-center m-b-10">
        <div class="text-left workspace-title">
          <fui-heading [text]="'Connection with ' + connectionData.name" [level]="5"></fui-heading>
        </div>
        <div class="text-right workspace-action">
          <!-- <span class="btn btn-secondary" (click)="editWorkspace()"><fa-icon icon="edit"></fa-icon>&nbsp;{{ "general.settings" | translate }}</span> -->
        </div>
      </div>
    </ng-container>
    <div class="row m-b-10 d-none d-lg-none" [class.d-block]="selectedView == 'details'">
      <div class="col">
        <div class="view-chooser-container d-flex">
          @if (!batchOperationMode) {
            <div class="view-chooser white" style="width: 100%">
              <div class="option" [class.selected]="selectedView == 'conversation'" (click)="selectView('conversation')">Conversation</div>
              <!-- <div class="option" [class.selected]="selectedView == 'files'" (click)="selectView('files')">
              {{ "sphere.workspaces.shared_files" | translate | uppercase }}
              <span class="unread-badge" *ngIf="totalUnreadFileMessages">{{ totalUnreadFileMessages }}</span>
            </div> -->
              <div class="option d-block d-lg-none" [class.selected]="selectedView == 'details'" (click)="selectView('details')">{{ "sphere.details" | translate | uppercase }}</div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="d-none d-lg-block workspace-sidebar" [style]="'width: ' + detailsWidth + '; margin-right: 15px; min-width: 300px;'" [class.d-block]="selectedView == 'details'">
        <ng-container *ngTemplateOutlet="detailContent"></ng-container>
      </div>
      <div class="d-none d-lg-block overflow-hidden flex-fill" [class.d-block]="selectedView == 'conversation' || selectedView == 'files'">
        <div class="row m-b-10">
          <div class="col">
            <div class="view-chooser-container d-flex">
              @if (!batchOperationMode) {
                <div class="view-chooser white" style="width: 100%">
                  <div class="option" [class.selected]="selectedView == 'conversation'" (click)="selectView('conversation')">Conversation</div>
                  <!-- <div class="option" [class.selected]="selectedView == 'files'" (click)="selectView('files')">
                {{ "sphere.workspaces.shared_files" | translate | uppercase }}
                <span class="unread-badge" *ngIf="totalUnreadFileMessages">{{ totalUnreadFileMessages }}</span>
              </div> -->
                  <div class="option d-block d-lg-none" [class.selected]="selectedView == 'details'" (click)="selectView('details')">{{ "sphere.details" | translate | uppercase }}</div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row" #conversationFilesView style="overflow: hidden" [ngStyle]="{ height: conversationFilesViewHeight + 'px' }">
          <div class="col-md-12 h-full">
            <div class="discussion-files-view" [ngStyle]="{ opacity: this.connectionData.status == 'active' ? 1 : '0.4' }">
              @if (selectedView != "files" && !loadingConversation && (!displayedMessages || !displayedMessages.length)) {
                <div class="timeline-instruction-overlay">
                  <div class="text-center">
                    <span class="brandfont-bold">Conversation</span>
                    @if (myWorkspace && workspace.collaborators.length == 1) {
                      <div>
                        {{ "sphere.invite_collaborator" | translate }}
                        <br />
                        <br />
                        <button class="small-btn" (click)="manageCollaborators()">{{ "sphere.workspaces.manage_collaborators" | translate }}</button>
                      </div>
                    }
                    @if ((myWorkspace && workspace.collaborators.length > 1) || !myWorkspace) {
                      <div>Its awfully quiet in here. Send a message below!</div>
                    }
                  </div>
                </div>
              }
              @if (attingCollabs && attingCollabs.length) {
                <div class="atting-collabs">
                  @for (user of attingCollabs; track user) {
                    <div (click)="selectAtCollab(user)" class="pointer" [class.selected]="highlightedAtCollab.user_id == user.user_id">{{ user.name }}</div>
                  }
                </div>
              }
              <div [class.visible]="typingUsers && typingUsers.length" class="users-typing d-flex justify-content-center align-items-center">
                @if (typingUsers && typingUsers.length) {
                  <div class="m-r-10">{{ "sphere.workspaces.typing" | translate }}:</div>
                }
                @for (id of typingUsers; track id) {
                  <div class="m-r-10 typing-user">
                    <img [src]="connectionData.photo ? connectionData.photo : './assets/images/default_avatar.jpg'" style="width: 20px; height: 20px; border-radius: 10px; margin-right: 5px" />
                    {{ connectionData.name }}
                  </div>
                }
              </div>
              <div class="h-full">
                @if (loadingConversation && selectedView != "files") {
                  <div class="d-flex justify-content-center align-items-center t-30 h-full">
                    <myp-inline-loader [loading]="true" height="200px" spinnerName="conversationLoader"></myp-inline-loader>
                  </div>
                }
                @if (selectedView != "files") {
                  <div class="h-full">
                    <div #chatWindow class="discussion-container h-full" [ngStyle]="{ 'border-radius': '10px 10px 0px 0px' }">
                      @if (!showingAllMessages && !loadingConversation) {
                        <div class="text-center">
                          @if (displayedMessages.length == 100) {
                            <button class="small-btn" (click)="initMessages(true)">Get Older Messages</button>
                          }
                        </div>
                      }
                      @for (msg of displayedMessages; track msg) {
                        @if (msg.type == "message") {
                          <div class="msg-container" [class.me]="msg.author.id == user.id" [class.them]="msg.author.id != user.id">
                            <img [src]="msg.author.photo || './assets/images/default_avatar.jpg'" class="profile-photo" />
                            <div class="msg">
                              @if (msg.type == "message") {
                                <span class="text" [innerHTML]="msg.message"></span>
                              }
                              <span class="timestamp d-block">
                                {{ msg.timestamp.toDate() | date: "MMM Do [at] hh:mm" : true }} &nbsp;
                                @if (msg.author.id != user.id) {
                                  <span>{{ msg.author.name }}&nbsp;</span>
                                }
                                @if (msg.edited) {
                                  <span class="c-gray">Edited&nbsp;&nbsp;</span>
                                }
                                @if (msg.author.id == user.id) {
                                  <span class="msg-options-link" (click)="msgOptions(msg)">{{ "sphere.options" | translate }}</span>
                                }
                              </span>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="msg-input">
          <myp-message-input
            #msgInput
            [type]="'span'"
            inputID="main-input"
            (valueChanged)="messageValueChange($event)"
            (returnPressed)="addMessage($event)"
            placeholder="Enter a message..."
            [includeSendButton]="true"
            ariaLabelBy="comment-label"
          ></myp-message-input>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #detailContent>
  <div class="image-container metro-profile-photo">
    @if (connectionData.photo) {
      <img class="w-full border-radius10 pointer image-border round metro-profile-photo" (click)="showImage(connectionData.photo)" [src]="connectionData.photo" />
    }
  </div>
  <div class="text-center m-t-30">
    <span class="t-20 bold d-block m-b-10">{{ connectionData.name }}</span>
    <span class="t-16 bold d-block m-b-20">{{ connectionData.email }}</span>
    <a [routerLink]="['/profile', connectionData.userId]" class="small-btn">View Profile</a>
  </div>
  @if (this.connectionData.status == "deleted") {
    <div class="m-y-20 p-10 text-center" style="background-color: red; border-radius: 10px">
      THIS CONNECTION HAS BEEN DELETED BY {{ connectionData.name.toUpperCase() }}
      <br />
      <br />
      <button class="btn btn-danger" (click)="deleteInvitation()">Remove Connection</button>
    </div>
  }
</ng-template>
